import { Route } from '@angular/router';

import { APP_ROUTE_PATHS } from '@ps/core-config';

import { legacyUnderConstruction } from './utils/under-construction.helper';
import { numericParamGuard } from './utils/numeric-param.guard';
import { createSurveyAccessGuard } from '@ps/survey-data-access';
import {
  launchSurveyResolver,
  surveyResolver,
} from '@ps/survey-creation-data-access';
import {
  SURVEY_WORKFLOW_PAGE,
  SURVEY_WORKFLOW_PAGE_DATA_KEY,
} from '@ps/survey-utils';

// UPDATE THE ROUTES BELOW WHEN ADDING THE PAGE COMPONENTS

export const SURVEY_ROUTES: Route[] = [
  legacyUnderConstruction(APP_ROUTE_PATHS.createTemplate, '/create-templates'),
  legacyUnderConstruction(
    APP_ROUTE_PATHS.importDecipherSurvey,
    '/import-decipher-survey',
  ),
  legacyUnderConstruction(APP_ROUTE_PATHS.recontactSurvey, '/recontact-survey'),
  {
    path: APP_ROUTE_PATHS.manageSurvey,
    loadComponent: () =>
      import('../pages/manage-survey/manage-survey.page').then(
        (m) => m.ManageSurveyPage,
      ),
    title: 'Manage Survey',
    canActivate: [numericParamGuard('id')],
  },
];

/**
 * Survey workflow pages render their own page-specific navbar and have no sidebar,
 * so they're nested under `SurveyWorkflowLayoutComponent` in `app.routes.ts` instead
 * of the standard `AppLayoutComponent` shell that `SURVEY_ROUTES` above sits under.
 */
export const SURVEY_WORKFLOW_ROUTES: Route[] = [
  {
    path: APP_ROUTE_PATHS.createSurvey,
    loadComponent: () =>
      import('../pages/create-survey/create-survey.page').then(
        (m) => m.CreateSurveyPage,
      ),
    title: 'Create Survey',
    data: { [SURVEY_WORKFLOW_PAGE_DATA_KEY]: SURVEY_WORKFLOW_PAGE.CREATE },
    canActivate: [createSurveyAccessGuard],
  },
  {
    path: APP_ROUTE_PATHS.editSurvey,
    loadComponent: () =>
      import('../pages/edit-survey/edit-survey.page').then(
        (m) => m.EditSurveyPage,
      ),
    title: 'Edit Survey',
    data: { [SURVEY_WORKFLOW_PAGE_DATA_KEY]: SURVEY_WORKFLOW_PAGE.EDIT },
    canActivate: [numericParamGuard('id')],
    resolve: { survey: surveyResolver },
  },
  {
    path: APP_ROUTE_PATHS.launchSurvey,
    loadComponent: () =>
      import('../pages/survey-launch/survey-launch.page').then(
        (m) => m.SurveyLaunchPage,
      ),
    title: 'Launch Survey',
    data: { [SURVEY_WORKFLOW_PAGE_DATA_KEY]: SURVEY_WORKFLOW_PAGE.LAUNCH },
    canActivate: [numericParamGuard('id')],
    resolve: { survey: launchSurveyResolver },
  },
];
